export const getAll = ({ all }) => { return all };
export const getCreditor = ({ creditor }) => { return creditor };
export const getSaving = ({ saving }) => { return saving };
export const isLoading = ({ loading }) => { return loading };
export const isLoadingError = ({ loadingError }) => { return loadingError };
